import React from "react";
import logo from "../Assets/Images/logo.png";

export default function CoreBrand({ onClick, showName = true, className = "" }) {
  return (
    <div className={["ems-brand", className].filter(Boolean).join(" ")} onClick={onClick}>
      <img src={logo} alt="CORE" className="ems-brand-mark ems-logo-theme" />
      {showName ? <span className="ems-brand-name">CORE</span> : null}
    </div>
  );
}
